module.exports = __webpack_public_path__ + "img/from_speak_info_2_4x.57616911.png";